import { io } from 'socket.io-client';

const url = window.location.origin;

export const socket = io(url, {
  path: '/socket',
  // The bot sends deals once on connect, so App must register its listener before connecting.
  autoConnect: false,
});